import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';

/**
 * Router guard for private, admin-only pages. Renders children only for an
 * authenticated session; otherwise redirects to sign-in. This is the UI half
 * of defense-in-depth — the API routes independently enforce requireAdminAuth,
 * so an unauthenticated client never receives private data regardless.
 *
 * Used for the Trips section (declarative in App.tsx, parallel to FeatureGuard).
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-foreground" />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/auth/signin" replace />;

  return <>{children}</>;
}

export default RequireAdmin;
